// import React, { useState, useEffect } from 'react';
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
//   useLocation,
//   useNavigate,
// } from 'react-router-dom';

// import LoadAndErrorOverlay from './components/ui/LoadAndErrorOverlay';

// function App() {
//   const [pageHtm, setPageHtm] = useState();
//   const [isLoadingOrError, setIsLoadingOrError] = useState(true);
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const nid = params.get('nid');
//     console.log('nid: ' + nid);
//     if (!nid) {
//       navigate('https://www.apple.com', { replace: true }); // Redirect to an error page or a different URL
//     }
//   }, [location, navigate]);

//   // Load and Error Screens -- Begin

//   const atSuccessData = (resp) => {
//     console.log('Hello, this Note-Web. Commit# after 9b8982fe5e2a');

//     // Extracts the HTML content
//     const cleanHtmlMatch = resp.match(/<!DOCTYPE html>[\s\S]*<\/html>/i);
//     if (!cleanHtmlMatch) {
//       console.log('No valid HTML content found.');
//       setIsLoadingOrError(false);
//       return;
//     }

//     const cleanHtml = cleanHtmlMatch[0];
//     // console.log(cleanHtml);

//     // Create a DOM parser to manipulate the HTML content
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(cleanHtml, 'text/html');

//     // Serialize the modified HTML back to a string
//     const updatedHtml = doc.documentElement.outerHTML;

//     setPageHtm(updatedHtml);

//     setIsLoadingOrError(false);
//   };

//   function createMarkup(htmValue) {
//     return { __html: htmValue };
//   }

//   const HomePage = () => {
//     if (isLoadingOrError) {
//       return (
//         <LoadAndErrorOverlay pageName={'App'} onSuccessData={atSuccessData} />
//       );
//     }

//     return (
//       <div id="rContainer" dangerouslySetInnerHTML={createMarkup(pageHtm)} />
//     );
//   };

//   return (
//     <Router>
//       <Routes>
//         <Route exact path="/" element={<HomePage />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import LoadAndErrorOverlay from './components/ui/LoadAndErrorOverlay';

function HomePage() {
  const [pageHtm, setPageHtm] = useState();
  const [isLoadingOrError, setIsLoadingOrError] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const nid = params.get('nid');

    if (!nid) {
      // navigate('https://www.kualify.net', { replace: true }); // Redirect to an error page or a different URL
      window.location.href = 'http://www.kualify.net'; // Redirects to Apple
    }
  }, [location, navigate]);

  const atSuccessData = (resp) => {
    console.log('Hello, this Note-Web. Commit# after cc3411f52c2f');
    if (!resp) {
      return;
    }

    // Extracts the HTML content
    const cleanHtmlMatch = resp.match(/<!DOCTYPE html>[\s\S]*<\/html>/i);
    if (!cleanHtmlMatch) {
      console.log('No valid HTML content found.');
      setIsLoadingOrError(false);
      return;
    }

    const cleanHtml = cleanHtmlMatch[0];

    // Create a DOM parser to manipulate the HTML content
    const parser = new DOMParser();
    const doc = parser.parseFromString(cleanHtml, 'text/html');

    // Begin Preview code
    // Add Open Graph meta tags to <head>
    // const head = doc.head;

    // // Define or update Open Graph tags
    // const ogTags = [
    //   { property: 'og:title', content: 'Kualify' },
    //   { property: 'og:description', content: 'Lecture Notes & Flash Cards' },
    //   {
    //     property: 'og:image',
    //     content: 'https://www.kualify.net/kualify-image2.png',
    //   },
    //   { property: 'og:url', content: 'https://app.kualify.net' },
    // ];

    // ogTags.forEach(({ property, content }) => {
    //   // Remove existing tag if it exists
    //   const existing = head.querySelector(`meta[property="${property}"]`);
    //   if (existing) {
    //     existing.setAttribute('content', content);
    //   } else {
    //     const meta = doc.createElement('meta');
    //     meta.setAttribute('property', property);
    //     meta.setAttribute('content', content);
    //     head.appendChild(meta);
    //   }
    // });
    // End Preview code

    // Serialize the modified HTML back to a string
    const updatedHtml = doc.documentElement.outerHTML;

    setPageHtm(updatedHtml);
    setIsLoadingOrError(false);
  };

  function createMarkup(htmValue) {
    return { __html: htmValue };
  }

  if (isLoadingOrError) {
    return (
      <LoadAndErrorOverlay pageName={'App'} onSuccessData={atSuccessData} />
    );
  }

  return (
    <div id="rContainer" dangerouslySetInnerHTML={createMarkup(pageHtm)} />
  );
}

function ErrorPage() {
  return <h1>Error: Missing nid parameter</h1>;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/error-page" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}

export default App;
